var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5WarningExclamationMark = function SvgAv5WarningExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-variant": "regular",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E34646",
    "data-no-stroke": "true",
    "data-no-fill": "true"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4v5",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    "data-no-stroke": "true",
    "data-no-fill": "true"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1,
    fill: "#fff",
    "data-no-stroke": "true",
    "data-no-fill": "true"
  })));
};
export { SvgAv5WarningExclamationMark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLXZhcmlhbnQ9InJlZ3VsYXIiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI4IiBmaWxsPSIjRTM0NjQ2IiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIgZGF0YS1uby1maWxsPSJ0cnVlIi8+CiAgICA8cGF0aCBkPSJNOCA0TDggOSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGRhdGEtbm8tc3Ryb2tlPSJ0cnVlIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDxjaXJjbGUgY3g9IjgiIGN5PSIxMiIgcj0iMSIgZmlsbD0id2hpdGUiIGRhdGEtbm8tc3Ryb2tlPSJ0cnVlIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KPC9zdmc+Cg==";